<template>
  <div class="tabbar_wrap">
    <div :class="active==1? 'placeholder':''">
      <router-view />
    </div>
    <keep-alive>
      <!-- verConfig.tabbar.selectedColor ||  -->
      <template v-if="active == 1">
        <Tabbar v-model="active" @change="tabbarChange" active-color="var(--theme)"
          :inactive-color="theme == 'dark' ? 'rgba(255,255,255,.6)' : 'rgba(0,0,0,.6)'" route>
          <TabbarItem v-for="(item, index) in verConfig.tabbar.pages" :key="index" :name="index"
            :to="`/tabbar/${item.pagePath}`">
            <template #icon="props">
              <template v-if="item.type === 'image'">
                <div class="icon">
                  <div class="tar_item" :class="props.active ? 'active' : ''">
                    <img class="img" :src="item.selectedIconPath" alt="" />
                    <!-- <span class="textClass" :style="active == index ? {} : { opacity: 0 }">{{
                      $t(item.text) }}</span> -->
                  </div>
                </div>
              </template>
            </template>
          </TabbarItem>
        </Tabbar>
      </template>
    </keep-alive>
  </div>
</template>

<script>
import { Tabbar, TabbarItem } from "vant";
import { mapGetters } from "vuex";
export default {
  components: {
    Tabbar,
    TabbarItem,
  },
  data: () => ({
    // active: 0,
  }),
  created() { },
  methods: {
    handleClick() { },
    tabbarChange(index) {
      if (index == 1 && !this.userInfo.token) {
        this.$router.push('/login')
      }
    },
  },
  computed: {
    ...mapGetters(["theme", "userInfo"]),
    active: {
      get() {
        return this.$store.state.tabbar.active;
      },
      set(newVal) {
        return newVal;
      },
    },
  },
};
</script>

<style lang="less" scoped>
@bg: var(--white);

.tabbar_wrap {
  background: @bg;

  /deep/ .van-tabbar {
    max-width: 750px;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    background-color: var(--nav-background);
    .van-tabbar-item{
      border-right: 1px solid var(--white);
    }
  }
}

.placeholder {
  margin-bottom: calc(50rem / 16);
}

.iconfont {
  font-size: calc(22rem / 16);
}

// .van-tabbar-item{
//   position: relative;
// }
.van-tabbar-item--active {
  background-color: transparent;
}

/deep/ .van-tabbar-item__icon {
  width: 100%;
  margin-bottom: 0;
}

.icon {
  display: flex;
  align-items: center;
  justify-content: center;

  .tar_item {
    display: flex;
    align-items: center;
    border-radius: calc(30rem / 16);
    padding: 0 calc(15rem / 16);
    height: calc(35rem / 16);
    background-color: transparent;

    .img {
      // width: calc(22rem / 16);
      height: calc(35rem / 16);
      display: block;
    }

    .textClass {
      color: var(--white);
      font-size: calc(12rem / 16);
      margin-left: calc(5rem / 16);
      opacity: 1;
    }
  }

  .active {
    // background-color: #5343f4;
  }
}
</style>